import { useEffect, useState } from "react";

import { Outlet } from "react-router-dom";

import { wilmaSSODashboardUrl, wilmaSSOAppId, wilmaSAVCustomerId } from "../config";

import {
  ArchiveBoxArrowDownIcon,
  ArchiveBoxIcon,
  ArrowUturnUpIcon,
  BanknotesIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
  CameraIcon,
  ChatBubbleLeftEllipsisIcon,
  ClipboardDocumentCheckIcon,
  ClockIcon,
  Cog6ToothIcon,
  Cog8ToothIcon,
  CurrencyPoundIcon,
  DocumentCurrencyPoundIcon,
  DocumentMagnifyingGlassIcon,
  DocumentTextIcon,
  FolderPlusIcon,
  XCircleIcon,
  HomeIcon,
  InboxStackIcon,
  MagnifyingGlassPlusIcon,
  NewspaperIcon,
  TagIcon,
  WrenchScrewdriverIcon,
  MapIcon,
  BuildingStorefrontIcon,
  TicketIcon,
  BookOpenIcon,
  TruckIcon,
  CalculatorIcon,
  MagnifyingGlassIcon,
  EyeSlashIcon,
  AdjustmentsHorizontalIcon,
  WrenchIcon,
  PresentationChartBarIcon,
} from "@heroicons/react/24/outline";

import Topbar from "../components/shared/Navbar/Topbar";
import LoadingWheel from "../components/shared/LoadingWheel";
import { NavigationItemInterface } from "../types/Navigation";
import { usePageNameContext } from "../contexts/PageTitleContext";
import MobileSidebar from "../components/shared/Navbar/MobileSidebar";
import DesktopSidebar from "../components/shared/Navbar/DesktopSidebar";
import { useAuth } from "../contexts/AuthContext";
import useOnboarding from "../data/useOnboarding";
import { isMobileViewport } from "../hooks/useIsMobile";
import { impersonationColour } from "../utils/impersonation";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const staffNavigation: NavigationItemInterface[] = [
  // { name: "Dashboard", to: "/", icon: HomeIcon },

  { name: "Leads", to: "/", icon: FolderPlusIcon, group: "Leads" },
  { name: "Postcode Prices", to: "scrap-price", icon: DocumentCurrencyPoundIcon, group: "Leads" },
  // { name: "Collected", to: "vehicles-collected", icon: ArchiveBoxIcon, group: "Leads" },
  // //{ name: "Calendar", to: "calendar", icon: CalendarDaysIcon },
  // { name: "Trip Manager", to: "trip-manager", icon: CalendarDaysIcon, group: "Leads" },
  // { name: "Payments", to: "payments", icon: BanknotesIcon, group: "Leads" },
  // { name: "Schedule", to: "schedule", icon: NewspaperIcon, group: "Leads" },

  // { name: "Awaiting Inventory", to: "parts-manager", icon: WrenchScrewdriverIcon, group: "Parts", disabled: true },
  // { name: "Awaiting Arrival", to: "awaiting-arrival", icon: ClockIcon, group: "Parts", disabled: true },
  // { name: "Parts Checker", to: "parts-checker", icon: ClipboardDocumentCheckIcon, group: "Parts", disabled: true },
  // { name: "Jobs", to: "jobs", icon: BriefcaseIcon, group: "Parts", disabled: true },
  // { name: "Stock", to: "stock", icon: InboxStackIcon, group: "Parts", disabled: true },

  // { name: "eBay Unlisted", to: "ebay-unlisted", icon: DocumentTextIcon, group: "eBay", disabled: true },
  // { name: "eBay Listings", to: "ebay-listings", icon: CurrencyPoundIcon, group: "eBay", disabled: true },
  // { name: "eBay Orders", to: "ebay-orders", icon: ArchiveBoxArrowDownIcon, group: "eBay", disabled: true },
  // { name: "eBay Returns", to: "ebay-returns", icon: ArrowUturnUpIcon, group: "eBay", disabled: true },

  // { name: "Vehicles", to: "vehicles", icon: TruckIcon },
  // { name: "Contacts", to: "contacts", icon: UsersIcon },
];

const driverNavigation: NavigationItemInterface[] = [
  // { name: "Find Lead", to: "find-lead", icon: DocumentMagnifyingGlassIcon },
  { name: "Search", to: "/search", icon: MagnifyingGlassIcon, group: "Leads" }
];

const adminNavigation: NavigationItemInterface[] = [
  // { name: "Dashboard", to: "/", icon: HomeIcon },

  { name: "Leads", to: "/", icon: FolderPlusIcon, group: "Leads" },
  { name: "Calculator", to: "calculate", icon: CalculatorIcon, group: "Leads" },
  { name: "SellAVehicle", to: "sellavehicle", icon: TruckIcon, group: "Leads" },
  { name: "Quote History", to: "abandoned-quotes", icon: BookOpenIcon, group: "Leads" },
  { name: "Quote Map", to: "quote-map", icon: MapIcon, group: "Leads" },

  { name: "Postcode Prices", to: "scrap-price", icon: DocumentCurrencyPoundIcon, group: "Settings" },
  { name: "Price Adjustments", to: "price-settings", icon: Cog8ToothIcon, group: "Settings" },
  { name: "Suppliers", to: "suppliers", icon: BuildingStorefrontIcon, group: "Settings" },
  { name: "Vouchers", to: "vouchers", icon: TicketIcon, group: "Settings" },
  { name: "Collection Options", to: "collection-options", icon: AdjustmentsHorizontalIcon, group: "Settings" },
  // { name: "Collected", to: "vehicles-collected", icon: ArchiveBoxIcon, group: "Leads" },
  // //{ name: "Calendar", to: "calendar", icon: CalendarDaysIcon, group: "Leads" },
  // { name: "Trip Manager", to: "trip-manager", icon: CalendarDaysIcon, group: "Leads" },
  // { name: "Payments", to: "payments", icon: BanknotesIcon, group: "Leads" },
  // { name: "Schedule", to: "schedule", icon: NewspaperIcon, group: "Leads" },

  // { name: "Awaiting Inventory", to: "parts-manager", icon: WrenchScrewdriverIcon, group: "Parts", disabled: true },
  // { name: "Awaiting Arrival", to: "awaiting-arrival", icon: ClockIcon, group: "Parts", disabled: true },
  // { name: "Parts Checker", to: "parts-checker", icon: ClipboardDocumentCheckIcon, group: "Parts", disabled: true },
  // { name: "Jobs", to: "jobs", icon: BriefcaseIcon, group: "Parts", disabled: true },
  // { name: "Stock", to: "stock", icon: InboxStackIcon, group: "Parts", disabled: true },

  // { name: "eBay Unlisted", to: "ebay-unlisted", icon: DocumentTextIcon, group: "eBay", disabled: true },
  // { name: "eBay Listings", to: "ebay-listings", icon: CurrencyPoundIcon, group: "eBay", disabled: true },
  // { name: "eBay Orders", to: "ebay-orders", icon: ArchiveBoxArrowDownIcon, group: "eBay", disabled: true },
  // { name: "eBay Returns", to: "ebay-returns", icon: ArrowUturnUpIcon, group: "eBay", disabled: true },
  // { name: "eBay Messages", to: "ebay-messages", icon: ChatBubbleLeftEllipsisIcon, group: "eBay", disabled: true },

  // { name: "Find Lead", to: "find-lead", icon: DocumentMagnifyingGlassIcon, group: "Admin" },
  // { name: "Category Editor", to: "category-editor", icon: TagIcon, group: "Admin" },
  // { name: "Required Images", to: "category-images", icon: CameraIcon, group: "Admin" },
  // { name: "Driver Tracking", to: "driver-tracking", icon: MagnifyingGlassPlusIcon, group: "Admin" },
  { name: "Admin Settings", to: "admin", icon: Cog6ToothIcon, group: "Admin" },
  { name: "Hidden Pages", to: "hidden-pages", icon: EyeSlashIcon, group: "Admin" },
  // { name: "Vehicles", to: "vehicles", icon: TruckIcon },
  // { name: "Contacts", to: "contacts", icon: UsersIcon },
];

const savNavigation: NavigationItemInterface[] = [
  { name: "Leads", to: "/", icon: FolderPlusIcon, group: "Leads" },
  { name: "SellAVehicle", to: "sellavehicle", icon: TruckIcon, group: "Leads" },
  { name: "Quote History", to: "abandoned-quotes", icon: BookOpenIcon, group: "Leads" },
  { name: "Quote Map", to: "quote-map", icon: MapIcon, group: "Leads" },
  { name: "Analytics", to: "analytics", icon: PresentationChartBarIcon, group: "Leads" },
  { name: "Postcode Prices", to: "scrap-price", icon: DocumentCurrencyPoundIcon, group: "Settings" },
  { name: "Price Adjustments", to: "price-settings", icon: Cog8ToothIcon, group: "Settings" },
  { name: "Suppliers", to: "suppliers", icon: BuildingStorefrontIcon, group: "Settings" },
  { name: "Vouchers", to: "vouchers", icon: TicketIcon, group: "Settings" },
  { name: "Collection Options", to: "collection-options", icon: AdjustmentsHorizontalIcon, group: "Settings" },

  { name: "Admin Settings", to: "admin", icon: Cog6ToothIcon, group: "Admin" },
  { name: "Functions", to: "functions", icon: WrenchIcon, group: "Admin" },
];

export default function DashboardLayout() {
  const {
    pageInfo: { name, desc },
  } = usePageNameContext();
  const { loading, loggedIn, claims, customerId, impersonating } = useAuth();
  // Desktop starts with the sidebar expanded; on phones the drawer starts closed.
  const [sidebarOpen, setSidebarOpen] = useState(() => !isMobileViewport());
  const [searchParams] = useSearchParams();
  const [embedded, setEmbedded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // First-login onboarding: admins of a customer that hasn't completed (or skipped) the wizard are sent to it.
  // The status query is the same one the wizard uses, so by the time we redirect it's already in the cache and
  // the wizard renders immediately. Until we know, the page behind is held so Leads doesn't flash first.
  // Not while SAV is viewing as a customer - SAV shouldn't be pushed into another customer's wizard.
  const isAdmin = !loading && loggedIn && claims?.isAdmin === true && !impersonating;
  const { status: onboarding } = useOnboarding(isAdmin);
  const needsOnboarding = onboarding.data?.data.onboardingCompleted === false;
  const onboardingPending = isAdmin && onboarding.isLoading && !onboarding.isError;

  useEffect(() => {
    if (needsOnboarding && location.pathname !== "/onboarding") {
      navigate("/onboarding", { replace: true });
    }
  }, [needsOnboarding, location.pathname, navigate]);

  useEffect(() => {
    const embed = searchParams.get("embed");
    if (embed) setEmbedded(embed == "true");
  }, [searchParams]);

  const getNavigation = () => {
    // SAV viewing as a customer gets that customer's full admin menu, whatever SAV's own role is
    if (impersonating) {
      return adminNavigation;
    }

    if (wilmaSAVCustomerId == customerId) {
      return savNavigation;
    }

    if (claims) {
      if (claims.isAdmin) {
        return adminNavigation;
      } else if (claims.isStaff) {
        return staffNavigation;
      } else if (claims.isDriver) {
        return driverNavigation;
      }
    }

    return [];
  };

  useEffect(() => {
    if (claims) {
      if (claims.isAdmin) {

      } else if (claims.isStaff) {

      } else if (claims.isDriver && window.location.pathname === "/") {
        window.location.href = "/search";
      }
    }
  }, [claims]);

  useEffect(() => {
    console.log(loading, loggedIn);

    if (!loading && !loggedIn) {
      window.location.assign(
        `${wilmaSSODashboardUrl}?app=${wilmaSSOAppId}&returnUrl=${window.location.href}`
      );
    }

  }, [loading, loggedIn])

  // console.log(loading || !loggedIn);

  // A frame round the whole window in the customer's colour while SAV is viewing as them
  const impersonationFrame = impersonating && (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[60] border-4"
      style={{ borderColor: impersonationColour(impersonating) }}
    />
  );

  const pageContent = (
    <div className={`flex flex-1 flex-col min-w-0 ${!embedded && sidebarOpen ? "md:pl-60" : ""}`}>
      {impersonationFrame}
      {!embedded && <Topbar setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />}
      <main className="min-w-0">
        <div className="py-4 sm:py-6">
          <div className="mt-2 px-4 sm:px-6 prose max-w-none">
            <h1 className="font-semibold text-gray-900 mb-0 text-2xl sm:text-3xl break-words">{name}</h1>
            <h4 className="text-sm sm:text-base font-medium text-gray-500 mt-1">
              {desc}
            </h4>
          </div>
          <div className="px-4 sm:px-6 min-w-0 overflow-x-hidden">
            {onboardingPending || (needsOnboarding && location.pathname !== "/onboarding") ? (
              <div className="min-h-[300px]">
                <LoadingWheel />
              </div>
            ) : (
              <Outlet />
            )}
          </div>
        </div>
      </main>
    </div>
  )

  if (loading || !loggedIn) return (
    <div className="h-screen w-screen flex items-center justify-center">
      <LoadingWheel />
    </div>
  );

  if (embedded) return pageContent;

  return loading || !loggedIn ? (
    <div className="h-screen w-screen flex items-center justify-center">
      <LoadingWheel />
    </div>
  ) : (
    <div>
      <MobileSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        navigation={getNavigation()}
      />
      <DesktopSidebar sidebarOpen={sidebarOpen} navigation={getNavigation()} />
      {pageContent}
      {/* <div className="flex flex-1 flex-col md:pl-60">
        <Topbar setSidebarOpen={setSidebarOpen} />
        <main>
          <div className="py-6">
            <div className="mt-2 px-4 sm:px-6 md:pl-20 prose">
              <h1 className="font-semibold text-gray-900 mb-0">{name}</h1>
              <h4 className="text-base font-medium text-gray-500 mt-1">
                {desc}
              </h4>
            </div>
            <div className="px-4 sm:px-6 md:px-20">
              <Outlet />
            </div>
          </div>
        </main>
      </div> */}
    </div>
  );
}
